<template>
  <div class="graduate">
    <indexTitle>
        <template v-slot:title>
            招生信息
        </template>
        <template v-slot:eng>
            Admission Information
        </template>
    </indexTitle>
    <div class="student">
<!--         <div class="left-title">
            <a href="javascript:;" :class="{active: activeTab === 0}" @mouseenter="activeTab = 0" @click="$router.push({ path: '/graduate', query: { type: 'zsxx',subtitle: 'zsxx' } })">招生信息</a>
            <a href="javascript:;" :class="{active: activeTab === 1}" @mouseenter="activeTab = 1" @click="$router.push({ path: '/graduate', query: { type: 'xshd',subtitle: 'zsxx' } })">学生活动</a>
        </div> -->

        <div class="right-cont">
        <!-- 招生信息 -->
            <div>
                <a href="javascript:;" class="btn" @click="$router.push({ path: '/graduate', query: { type: 'zsxx',subtitle: 'zsxx' } })">
                    <div class="fix">
                        <div class="info">
                            <p v-if="admissionSummary">{{ admissionSummary }}</p>
                            <h2 v-else>{{admissionInfo.title}}</h2>
                        </div>
                        <div class="more">了解详情 &gt; </div>
                    </div>
                </a>
            </div>
<!--             <div v-show="activeTab === 1">
                <ul class="row">
                  <li class="act" v-for="(item, index) in activeList.slice(0, 3)" :key="index">
                    <a href="javascript:;" class="info-link" @click="$router.push({ path: '/graduate/detail', query: { type: 'xshd',subtitle: 'zsxx' ,id:item.id} })">
                      <div class="date-box">
                        <p>学生活动</p>
                        <div class="date">
                          <div>{{ formatDate(item.publishTime, 'day') }}</div>
                          <div>{{ formatDate(item.publishTime, 'yearMonth') }}</div>
                        </div>
                      </div>
                      <div class="info">
                        <div class="title">{{item.title}}</div>
                        <div class="more">了解详情 &gt; </div>
                      </div>

                    </a>
                  </li>

                </ul>

            </div> -->
        </div>
    </div>
  </div>
</template>

<script>
import { getActiveList, getAdmissionInfo } from '@/api/graduate.js'

export default {
  name: 'indexGraduate',
  data () {
    return {
      activeTab: 0, // 0=招生信息 1=学生活动
      activeList: [],
      admissionInfo: {}
    }
  },
  mounted () {
    this.fetchActiveList()
    this.fetchAdmissionInfo()
  },
  computed: {
    admissionSummary () {
      return this.extractAdmissionSummary(this.admissionInfo.content || this.admissionInfo.markdown || this.admissionInfo.introduction || '')
    }
  },
  methods: {
    switchTab (index) {
      this.activeTab = index
    },
    extractAdmissionSummary (markdownStr) {
      if (!markdownStr) return ''
      const cleaned = markdownStr
        .replace(/\r/g, '')
        .replace(/!\[[^\]]*]\([^)]*\)/g, '')
        .split('\n')
        .filter(line => {
          const text = line.trim()
          return text && !/^#{1,6}\s/.test(text) && !/^[-*_]{3,}$/.test(text)
        })
        .join('\n')
      const firstTextBlock = (cleaned
        .split(/\n{2,}/)
        .map(block => block.trim())
        .filter(Boolean)
      )[0] || ''
      const plainText = firstTextBlock
        .replace(/\[([^\]]+)]\([^)]*\)/g, '$1')
        .replace(/[*_`>#-]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
      return plainText.length > 92 ? `${plainText.slice(0, 92)}...` : plainText
    },
    async fetchActiveList () {
      try {
        const res = await getActiveList()
        if (res?.code === 1 && res.data && Array.isArray(res.data.rows)) {
          this.activeList = res.data.rows
        }
      } catch (err) {
        console.error('获取学生活动失败:', err)
      }
    },
    async fetchAdmissionInfo () {
      try {
        const res = await getAdmissionInfo()
        if (res?.code === 1 && res.data) {
          this.admissionInfo = res.data
        }
      } catch (err) {
        console.error('获取招生信息失败:', err)
      }
    },
    formatDate (timeStr, type) {
      if (!timeStr) return ''
      const date = new Date(timeStr)
      const y = date.getFullYear()
      const m = (date.getMonth() + 1).toString().padStart(2, '0')
      const d = date.getDate().toString().padStart(2, '0')
      if (type === 'day') return d
      if (type === 'yearMonth') return `${y}-${m}`
      return `${y}-${m} / ${d}`
    }
  }
}
</script>

<style lang="less">
.graduate{
    height:344px;
    padding:53px 107px;
    .student{
        height:auto;
        min-height:150px;
        margin-top: -20px;
        overflow: visible;
        .left-title{
            float: left;
            width: 250px;
            margin-right: 20px;
            margin-top: 13px;
            a{
                display:block;
                width:250px;
                height:66px;
                color: #0E6BB6;
                font-family: YouSheBiaoTiHei;
                font-size: 24px;
                line-height: 66px;
                margin-bottom: 7px;
                padding-left: 44px;
                background: url('@/assets/bg4.png') no-repeat left center;
                background-size: 100% 100%;
            }
            a:hover,
            .active{
                color: #fff;
                background: url('@/assets/bg5.png') no-repeat left center;
                background-size: 100% 100%;
            }
        }
        .right-cont{
            overflow: visible;
            padding: 13px;
            .btn{
                display: block;
                min-height: 140px;
                background: url('@/assets/xuesheng.webp') no-repeat center center;
                background-size: cover;
                border-radius: var(--radius-md);
                overflow: hidden;
                padding: 41px 73px 40px 53px;
                box-shadow: 0 16px 36px rgba(10, 54, 92, 0.12);
                transition: transform 0.32s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.32s ease;
                &:hover{
                  transform: translateY(-6px);
                  box-shadow: 0 22px 46px rgba(10, 54, 92, 0.18);
                }
                .info{
                    float:left;
                    max-width: min(68%, 680px);
                    h2{
                        font-weight: bold;
                        font-size: 18px;
                        color: #FFFFFF;
                        line-height: 24px;
                        margin-bottom: 11px;
                        overflow: hidden;
                    }
                    p{
                        font-size: 14px;
                        color: #FFFFFF;
                        line-height: 24px;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                        text-shadow: 0 1px 4px rgba(0,0,0,.36);
                    }
                }
                .more{
                    float:right;
                    width: 100px;
                    height: 30px;
                    border-radius: 15px;
                    border: 1px solid #FFFFFF;
                    font-size: 9px;
                    color: #FFFFFF;
                    line-height: 28px;
                    margin-top: 12px;
                    text-align: center;
                }
            }
            .row{
                margin: 0 -16px;
                width:797px;
                height:140px;
                .act{
                    float: left;
                    position: relative;
                    padding: 0 16px;
                    width: 33.33333333%;
                    .info-link{
                        display: block;
                        min-height: 140px;
                        background: #FFFFFF url('@/assets/bg61.png') no-repeat center bottom;
                        background-size: 100% auto;
                        box-shadow: 0px 2px 13px 0px rgba(14, 107, 182, 0.15);
                        border-radius: 13px;
                        padding: 26px 26px 20px 26px;
                        &:hover .info .title{
                          color:#0E6BB6;
                        }
                        .date-box{
                            float: left;
                            width: 54px;
                            height: 60px;
                            margin-right: 26px;
                            margin-left: -40px;
                            background: #D8EEFF;
                            border-radius: 4px;
                            overflow: hidden;
                            text-align: center;
                            p{
                                height: 20px;
                                background: #0E6BB6;
                                border-radius: 4px 4px 0px 0px;
                                font-size: 9px;
                                color: #FFFFFF;
                                line-height: 20px;
                            }
                            .date{
                                font-size: 9px;
                                color: #0E6BB6;
                                line-height: 1;
                                padding-top: 5px;
                                div:nth-child(1) {
                                font-weight: bold;
                                font-size: 17px;
                                }
                            }
                        }
                        .info{
                            overflow: hidden;
                            .title{
                                font-weight: bold;
                                font-size: 13px;
                                color: #333333;
                                line-height: 20px;
                                word-break: break-word;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                                height: 60px;
                                margin-bottom: 20px;
                            }
                            .more{
                                font-weight: 400;
                                font-size: 9px;
                                color: #0E6BB6;
                                line-height: 14px;
                                position: relative;
                                text-align: right;
                                padding-right: 7px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
